<template>
  <div class="login-verify-code">
    <div class="graphics-code">
      <FormInput
        ref="verifyCodeInputGraphicsCode"
        class="input"
        v-model="verifyCodeFormData.graphicsCode"
        :reg-exp="/[^0-9a-zA-Z]/g"
        :max-length="4"
        :placeholder="$t('请输入图形验证码')"/>
      <div
        class="btn graphics-code-btn"
        @click="handleGetGraphicsCode">
        <img :src="captchaImg" alt="graphics">
      </div>
    </div>
    <div class="verify-code">
      <FormInput
        ref="verifyCodeInputVerifyCode"
        class="input"
        v-model="verifyCodeFormData.verifyCode"
        :reg-exp="/[^0-9a-zA-Z]/g"
        :max-length="6"
        :placeholder="$t('请输入验证码')"/>
      <CountDown
        ref="countDown"
        class="btn verify-code-btn"
        color="#4A6AFF"
        inactive-style="border: 1px solid #D9DBE8; color: #BBC0D8;"
        :active="countDownActive"
        :total-count="120"
        @click="handleCountDownClick"/>
    </div>
    <p
      class="login-tip">
      {{ $t('验证码将发送到您注册时提交的手机及邮箱中，请注意查收') }}
    </p>
    <div
      class="login-tip"
      style="margin-top: 6px;"
      v-if="showVoice">
      {{ $t('收不到短信？') }}
      <span
        class="login-tip-voice"
        :class="voiceLoading ? 'disabled' : ''"
        @click="handleVoiceClick">
        {{ $t('获取语音验证码') }}
      </span>
      <span
        style="margin-left: 5px;"
        v-if="voiceCount">
        {{voiceCount}}s{{ $t('后获取') }}
      </span>
    </div>
    <el-button
      class="confirm-verify-login-btn"
      type="primary"
      :disabled="confirmBtnDisabled"
      @click="handleLogin">
      {{ $t('确定') }}
    </el-button>
  </div>
</template>

<script>
// usbKeyUtil
import { getSignDataByObj } from '@/utils/USBKeyUtil'
// encode
import { base64encode, utf16to8 } from '@/utils/enCodeAndDecode'
// http
import loginApi from '@/api/login'
import { mapState, mapMutations } from 'vuex'
import { getHrefParams } from '@/utils/utils'
import { getPromptOfVerifyCode } from '@/utils/lang'
export default {
  components: {
  },
  data () {
    return {
      // 当前url解析后的参数
      hrefParams: getHrefParams(),
      // 图形验证码id
      captchaId: '',
      // 图形验证码bas64地址
      captchaImg: '',
      verifyCodeFormData: {
        graphicsCode: '',
        verifyCode: ''
      },
      countDownLoading: false,
      // 获取语音验证码 根据后端接口响应来判断
      showVoice: false,
      // 已获取语音验证码
      voiceLoading: false,
      // 语音验证码倒计时
      voiceCount: 0,
      // 语音验证码定时器
      voiceTimer: null,
      // 客户年费缴存信息及证书到期情况
      reminderMsg: '',
      reminderMsgFlag: 0
    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    ...mapState('app', ['appInfo']),
    countDownActive () {
      const { customerId, userId } = this.userInfo
      const { graphicsCode } = this.verifyCodeFormData
      const { countDownLoading } = this
      if (countDownLoading) {
        return false
      }
      // 客户号 用户号 图形验证码
      if (!customerId || !userId || !graphicsCode || graphicsCode.length < 4) {
        return false
      }
      return true
    },
    confirmBtnDisabled () {
      const { customerId, userId } = this.userInfo
      const { graphicsCode, verifyCode } = this.verifyCodeFormData
      if (!customerId || !userId || !graphicsCode || graphicsCode.length < 4 || verifyCode.length < 4) {
        return true
      }
      return false
    }
  },
  created () {
    this.getGraphicsCode()
  },
  beforeDestroy () {
    this.voiceTimer && clearInterval(this.voiceTimer)
  },
  methods: {
    ...mapMutations('login', ['SET_LOGIN_STATE', 'SET_USER_INFO', 'SET_LOGIN_INFO']),
    // 获取图形验证码
    getGraphicsCode () {
      const { captchaId } = this
      return loginApi.getGraphicsCode({
        type: 'USER_LOGIN',
        captchaId
      }).then(res => {
        if (res) {
          const { captchaId, captchaBase64 } = res
          this.captchaId = captchaId
          this.captchaImg = `data:image/jpg;base64,${captchaBase64}`
        }
      }).catch(err => {
        console.error(err)
      })
    },
    handleGetGraphicsCode () {
      this.getGraphicsCode()
      this.$refs.verifyCodeInputGraphicsCode.$refs.input.focus()
    },
    // 获取短信验证码
    handleCountDownClick () {
      const { customerId: cstId, userId } = this.userInfo
      const { graphicsCode: captcha } = this.verifyCodeFormData
      const { captchaId } = this
      this.countDownLoading = true
      loginApi.getSmsCode({
        cstId,
        userId,
        captcha,
        captchaId,
        type: 'USER_LOGIN'
      }).then(res => {
        this.countDownLoading = false
        if (res) {
          this.$refs.countDown.startCountDown()
          const { email, mobile, showVoice } = res
          // FIXME: 1.voice的流程 哪种情况下showVoice会是true
          // 2.弹窗提示
          const message = getPromptOfVerifyCode(mobile, email)
          this.$talert(message, '系统提示', {
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.$refs.verifyCodeInputVerifyCode.$refs.input.focus()
          })
          this.showVoice = showVoice
        }
      }).catch(() => {
        // 刷新图形验证码
        this.getGraphicsCode()
        this.countDownLoading = false
      })
    },
    // 获取语音验证码
    handleVoiceClick () {
      const { customerId: cstId, userId } = this.userInfo
      const { graphicsCode: captcha } = this.verifyCodeFormData
      const { captchaId, voiceCount } = this
      // 防止多次点击
      if (voiceCount) {
        return
      }
      if (!cstId) {
        this.$warn('请输入客户号')
        return
      }
      if (!userId) {
        this.$warn('请输入用户号')
        return
      }
      if (!captcha) {
        this.$warn('请输入图形验证码')
        return
      }
      this.voiceLoading = true
      loginApi.getVoiceCode({
        cstId,
        userId,
        captcha,
        captchaId,
        type: 'USER_LOGIN'
      }).then(res => {
        this.voiceLoading = false
        if (res) {
          const message = 'CBiBank将给您拨打电话，通过语音播报验证码，请接听来电。'
          this.$talert(message, '系统提示').then(() => {
            this.$refs.verifyCodeInputVerifyCode.$refs.input.focus()
          })
          this.voiceCount = 300
          // 创建定时器
          this.voiceTimer = setInterval(() => {
            if (this.voiceCount <= 0) {
              clearInterval(this.voiceTimer)
              this.voiceTimer = null
              this.voiceCount = 0
              return
            }
            this.voiceCount -= 1
          }, 1000)
        }
      }).catch(() => {
        // 刷新图形验证码
        this.getGraphicsCode()
        this.voiceLoading = false
      })
    },
    // 登录
    async handleLogin () {
      const { customerId: cstId, userId } = this.userInfo
      const { graphicsCode, verifyCode } = this.verifyCodeFormData
      const { captchaId } = this
      const type = 'USER_LOGIN'
      // 1.校验验证码
      loginApi.checkSmsCode({
        cstId,
        userId,
        code: verifyCode,
        type
      }).then(() => {
        const transferName = '登录'
        const info = {
          obviousInfo: {
            交易名称: transferName,
            网银客户号: cstId,
            用户号: userId
          },
          hiddenInfo: {
            smsCode: verifyCode,
            // transactionCode是与后端约定的值 暂且按照旧企业网银的配置写死即可
            transactionCode: '00000000'
          }
        }
        getSignDataByObj.call(this, info, (signData) => {
          // 果仁宝需求新增判断企业是否缴费正常
          loginApi.checkCert({
            customerId: cstId,
            userId,
            currentBusinessCode: '00000000'
          }).then(res => {
            if (res) {
              // 证书到期日
              const { zcertEndDate, certFlag } = res
              // 0-证书未到期，1-证书已到期
              if (certFlag === '1') {
                const date = this.$_format.formatDate(zcertEndDate)
                this.reminderMsg = `您的证书于${date}到期，请尽快在安全中心更新证书，以免因证书到期无法使用网银。`
                this.reminderMsgFlag = 1
              } else {
                this.reminderMsg = '欢迎使用CBiBank企业网银！'
                this.reminderMsgFlag = 0
              }
              // 3.验证码登录
              const params = {
                cstId,
                userId,
                captcha: graphicsCode,
                captchaId,
                code: verifyCode,
                currentBusinessCode: '00000000',
                signData,
                transferName
              }
              loginApi.loginByVerifyCode(params).then(res => {
                if (res) {
                  const { sessionId, sessionCustomerId, sessionUserId, passwordSetFlag } = res
                  const { reminderMsg, reminderMsgFlag } = this
                  const transcode = base64encode(utf16to8('EMP_SID=' + sessionId + '&customerId=' + sessionCustomerId + '&userId=' + sessionUserId + '&reminderMsg=' + reminderMsg + '&reminderMsgFlag=' + reminderMsgFlag))
                  this.SET_LOGIN_INFO({
                    EMP_SID: sessionId,
                    customerId: sessionCustomerId,
                    userId: sessionUserId,
                    reminderMsg,
                    reminderMsgFlag,
                    passwordSetFlag
                  })
                  if (passwordSetFlag) {
                    // 首次登录 设置密码
                    this.SET_LOGIN_STATE('page-set-password')
                    return
                  }
                  if (this.hrefParams && this.hrefParams.redirect_uri) {
                    // 芝加哥优化需求 redirect_uri
                    window.location.href = window.decodeURIComponent(this.hrefParams.redirect_uri) + '?' + transcode
                  } else {
                    this.$router.replace({
                      name: 'Home'
                    })
                  }
                }
              }).catch(err => {
                console.error(err)
              })
            }
          }).catch((err) => {
            console.error(err)
          })
        })
      }).catch((err) => {
        console.error(err)
        this.verifyCodeFormData.verifyCode = ''
      })
    }
  }
}
</script>

<style scoped lang="less">
.login-verify-code {
  margin-top: 10px;
  .input {
    width: 200px;
    height: 46px;
    line-height: 46px;
    text-align: left;
  }
  .btn {
    width: 110px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 2px;
    border: 1px solid #D9DBE8;
    cursor: pointer;
  }
  .graphics-code {
    display: flex;
    justify-content: space-between;
    .graphics-code-btn {
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .verify-code {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    .verify-code-btn {
      font-size: 14px;
      font-weight: 400;
      color: #BBC0D8;
    }
  }
  .login-tip {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #A1A7C4;
    line-height: 14px;
    text-align: left;
    user-select: none;
    .login-tip-voice {
      color: #4A6AFF;
      cursor: pointer;
    }
    .disabled {
      cursor: not-allowed;
    }
  }
  .confirm-verify-login-btn {
    margin-top: 105px;
    width: 320px;
    height: 46px;
  }
}
</style>
